import { backSwipeState } from '@/stores/swipe.store.js'

export function useBackSwipeBlocker() {

  const blockSwipe = () => {
    console.log('block-swipe starting blockSwipe')
    backSwipeState.isDisabled = true
  }

  const unblockSwipe = () => {
    console.log('block-swipe destroy blockSwipe disabled')
    setTimeout(() => {
      console.log('block-swipe destroy blockSwipe')
      backSwipeState.isDisabled = false
    }, 100)
  }

  return { blockSwipe, unblockSwipe }
}
